import { initProductCarousels } from './productCarousel';
import './product-carousel.scss';
import '../../../utils/productItem/product-meta.scss';

initProductCarousels();
